import { useState } from "react";
import type { FaqItem } from "@/types/content";

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpen?: number;
}

export default function FaqAccordion({ items, defaultOpen = 0 }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  return (
    <div className="divide-y divide-background-200/70 overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-100 md:px-5"
              >
                <span className="flex items-start gap-3 text-sm font-medium text-foreground-950 md:text-base">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-accent-100 text-xs font-semibold text-accent-800">
                    Q
                  </span>
                  {item.q}
                </span>
                <i
                  className={`ri-add-line shrink-0 text-lg text-foreground-400 transition-transform ${
                    isOpen ? "rotate-45" : ""
                  }`}
                />
              </button>
            </h3>
            {isOpen && (
              <div className="px-4 pb-4 md:px-5">
                <p className="flex items-start gap-3 border-l-2 border-primary-200 pl-4 text-sm leading-relaxed text-foreground-600">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-xs font-semibold text-secondary-900">
                    A
                  </span>
                  <span>{item.a}</span>
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}